/**
 * Hook to access onboarding context
 */

import { useContext } from "react";
import { OnboardingContext } from "./onboarding-context";
import type { OnboardingContextType } from "./onboarding-context";

export const useOnboarding = (): OnboardingContextType => {
  const context = useContext(OnboardingContext);
  if (!context) {
    throw new Error("useOnboarding must be used within an OnboardingProvider");
  }
  return context;
};

